const mapper_options = {
  endpoint: 'reporting/pulse/social_statistics',
  recordClass: require('./record'),
  relations: {
    belongsTo: {
      brand: {
        foreignKey: 'brand_id',
        localField: 'brand'
      }
    }
  }
}

module.exports = (store) => {
  store.defineMapper('pulse_social_statistics', mapper_options)
}
